import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import TriggerPriceForm from './TriggerPriceForm';
import { formBunja } from './bunja/form';
import LimitTypeForm from './limit/LimitTypeForm';

const PriceForm = () => {
  const { priceTypeAtom } = useBunja(formBunja);
  const priceType = useAtomValue(priceTypeAtom);

  return (
    <>
      {/* Trigger Time order는 sunset되어 UI에서 제거됨 (Notion ERD-216 §11). */}
      {/* 백엔드 feature flag `enable_trigger_time_order=false`로 거부됨. */}
      {priceType === 'trigger' && <TriggerPriceForm />}
      {priceType === 'limit' && <LimitTypeForm />}
    </>
  );
};

export default PriceForm;
